import React from 'react';
interface SectionTagProps {
  icon?: string;
  children: React.ReactNode;
  tone?: 'orange' | 'gray';
}
export function SectionTag({
  icon,
  children,
  tone = 'orange'
}: SectionTagProps) {
  return <span className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs sm:text-sm font-semibold uppercase tracking-wider ${tone === 'orange' ? 'border-orange/30 bg-orange/10 text-orange' : 'border-white/10 bg-white/5 text-muted'}`} data-id="element-329" data-mp="3nntbys5m1n79">
      {icon && <span aria-hidden="true" data-id="element-330" data-mp="3sll3vm6999bg">{icon}</span>}
      {children}
    </span>;
}